<template>
  <div class="flex items-center justify-center flex-col w-full h-full overflow-auto no-scrollbar">
    <router-view></router-view>
    <div v-if="getProfileLoader">
      <!-- Loader  -->
      <!-- <clip-loader :color="'#2294FF'" :size="'36px'" /> -->
    </div>
    <template v-else-if="!isSetupComplete || (isSetupComplete && isAIPostsEmpty && !getPostsLoader && !postGenerationLoader)">
      <div v-if="!isSetupComplete || (isSetupComplete && route.name !== 'ai-content-library-profile')" class="fixed inset-0 bg-[#25262740] z-40"></div>
      <!-- z-[1005] to ensure it is above top header bar -->
      <div
        class="z-[1005] fixed top-[50%] left-[50%] right-auto overflow-auto no-scrollbar"
        style="transform: translate(-35%, -45%)"
      >
        <SetupPopupWrapper v-if="!isSetupComplete" />
        <GeneratePostPopup v-else-if="!getPostsLoader && route.name !== 'ai-content-library-profile'" />
      </div>
    </template>
  </div>
  <CustomGenerateModal />
  <PostSettingsModal />
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import SetupPopupWrapper from '@modules/publisher/ai-content-library/components/SetupPopupWrapper.vue'
import GeneratePostPopup from '@modules/publisher/ai-content-library/components/modals/GeneratePostPopup.vue'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'
import CustomGenerateModal from '@modules/publisher/ai-content-library/components/modals/CustomGenerateModal.vue'
import { useAIPostGeneration } from '@modules/publisher/ai-content-library/composables/useAIPostGeneration'
import PostSettingsModal from '@modules/publisher/ai-content-library/components/modals/PostSettingsModal.vue'
import { EventBus } from '@/src/modules/common/lib/event-bus'

const route = useRoute()
const store = useStore()
const {
  fetchBrandInfo,
  isSetupComplete,
  getProfileLoader,
  resetSetupInfo,
  resetBrandInfo,
  AIUserProfile,
  abortRequests: abortSetupRequests
} = useSetup()
const { getPosts, getPostsLoader, isAIPostsEmpty, resetSelectedPosts, postGenerationLoader, postSettingsForm, abortRequests } = useAIPostGeneration(AIUserProfile)

onMounted(async () => {
  getPostsLoader.value = true
  await fetchBrandInfo()
  await getPosts()

  // Load posts when workspace changes
  EventBus.$on('workspace-changed', refetchAIContentLibraryData)
})

onBeforeUnmount(() => {
  EventBus.$off('workspace-changed')
  resetAIContentLibraryData()
})

// Trigger survey when user navigates away from AI Content Library
onBeforeRouteLeave((to, from) => {
  // Only show the survey when navigating to a route outside of AI Content Library
  if (from.name?.includes('ai-content-library') && !to.name?.includes('ai-content-library') && !to.name?.includes('login')) {

    // need to hide frill survey 'hide does not work'
    const surveyModal = document.querySelector('.Frill_Survey');
    if (surveyModal) {
      surveyModal.style.display = 'block';
    }

    // Get user profile to include email with survey
    const userProfile = store.getters.getProfile
    const userEmail = userProfile?.email || ''

    window.Frill('survey', {
      key: process.env.VUE_APP_FRILL_SURVEY_KEY,
      // Include user identification for better feedback tracking
      user: {
        email: userEmail,
        id: userProfile?._id || '',
        name: userProfile?.full_name || userProfile?.first_name || ''
      }
    })
  }
  return true // Always allow navigation to proceed
})

const refetchAIContentLibraryData = async () => {
  // Abort any ongoing API requests before resetting data
  abortRequests()
  abortSetupRequests()
  resetAIContentLibraryData()
  getPostsLoader.value = true
  await fetchBrandInfo()
  await getPosts()
}

const resetAIContentLibraryData = () => {
  resetSetupInfo()
  resetBrandInfo()
  resetSelectedPosts()
  AIUserProfile.value = null

  postSettingsForm.value = {
    style: null,
    brand_voice: null,
    social_platform: null,
    language: null,
    theme: null,
    post_type: null,
    no_of_posts: null,
    caption_length: null,
    emoji_usage: null,
    hashtag_usage: null
  }
}
</script>
